import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from '../../../../shared/guard/authentication-guard';
import { Entity, HeaderMenuType } from '../../../../shared/store/view/types';
import { ModuleId } from '../../../../shared/store/navigation/types';
import { UserWorkAttendanceDashboardComponent } from './user-work-attendance-dashboard/user-work-attendance-dashboard.component';
import { SalesPersonAttendanceDashboardComponent } from './sales-person-attendance-dashboard/sales-person-attendance-dashboard.component';

// On the children: the router store reads the data of the deepest route, and ':userId' inherits none.
const salesPersonAttendanceDashboardData = {
  headerMenu: HeaderMenuType.Sales,
  moduleId: ModuleId.crm,
  entity: Entity.SalesPersonAttendanceDashboard,
  breadcrumb: { skip: true },
};

const routes: Routes = [
  {
    path: 'Crm',
    data: {
      breadcrumb: { label: ' ', alias: 'userWorkAttendanceDashboard' },
    },
    children: [
      {
        path: 'UserWorkAttendanceDashboard',
        component: UserWorkAttendanceDashboardComponent,
        canActivate: [AuthenticationGuard],
        data: {
          headerMenu: HeaderMenuType.Sales,
          moduleId: ModuleId.crm,
          entity: Entity.UserWorkAttendanceDashboard,
          breadcrumb: { skip: true },
        },
      },
    ],
  },
  {
    path: 'Crm',
    data: {
      breadcrumb: { label: ' ', alias: 'salesPersonAttendanceDashboard' },
    },
    children: [
      {
        path: 'SalesPersonAttendanceDashboard',
        component: SalesPersonAttendanceDashboardComponent,
        canActivate: [AuthenticationGuard],
        data: { breadcrumb: { skip: true } },
        // Children without a component: picking a salesperson from the menu keeps the page, its period
        // included, instead of rebuilding it under another route.
        children: [
          { path: '', children: [], data: salesPersonAttendanceDashboardData },
          {
            path: ':userId',
            children: [],
            data: salesPersonAttendanceDashboardData,
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AttendanceDashboardRoutingModule {}
